module.exports = __webpack_public_path__ + "static/media/submenu-comparacao.d7b45eae.svg";